// extracted by mini-css-extract-plugin
export default {"empty-container":"styles_empty-container__W7cQS","text-style":"styles_text-style__nZ2M5"};